import React from 'react';
import { Modal, View, Text, TouchableOpacity, useWindowDimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';

const deleteConfirmationModal = ({ visible, onClose, onConfirm, isApplyRecord }) => {
  const { width: screenWidth } = useWindowDimensions();
  const modalWidth = Math.min(screenWidth * 0.9, 500);
  const horizontalPadding = screenWidth <= 768 ? 3 : 23;
  const width = modalWidth <= 400 ? '100%' : modalWidth


  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}
    >
      <View style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}>
        <LinearGradient
          colors={['#FFB538', '#CF7C08']}
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          style={{
            paddingVertical: 30,
            paddingHorizontal: horizontalPadding,
            borderRadius: 15,
            alignItems: 'center',
            position: 'relative',
            width: width
          }}
        >
          <TouchableOpacity
            onPress={onClose}
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              zIndex: 10,
              padding: 5,
            }}
          >
            <Text style={{ fontSize: 24, color: '#000000', fontWeight: 'bold' }}>×</Text>
          </TouchableOpacity>
          <Text style={{
            fontSize: 24,
            marginBottom: 10,
            fontFamily: fontFamily.font300,
            textAlign: 'center',
            color: '#000000',
          }}>
            {isApplyRecord ? 'Confirm changes' : 'Are you sure?'}
          </Text>
          <Text style={{
            fontSize: 18,
            marginBottom: 5,
            fontFamily: fontFamily.font300,
            textAlign: 'center',
            color: '#000000',
          }}>
            {isApplyRecord ? 'All adjustments will be applied to the \n GroovePacker product database.' : 'If you proceed, the record will be permanently removed.'}
          </Text>
          <Text style={{
            fontSize: 20,
            marginBottom: 20,
            fontFamily: fontFamily.font300,
            textAlign: 'center',
            color: '#000000',
          }}>
            This action cannot be undone.
          </Text>

          <View style={{ flexDirection: 'row', justifyContent: 'space-between', gap: 15 }}>
            <TouchableOpacity
              style={{
                paddingHorizontal: 10,
                paddingVertical: 3,
                borderRadius: 15,
                minWidth: 100,
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#000000'
              }}
              onPress={onClose}
            >
              <Text style={{ color: '#000000', fontFamily: fontFamily.font300 }}>Cancel</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                paddingHorizontal: 10,
                paddingVertical: 3,
                borderRadius: 15,
                minWidth: 100,
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#000000'
              }}
              onPress={onConfirm}
            >
              <Text style={{ color: '#000000', fontFamily: fontFamily.font300 }}>{isApplyRecord ? 'Yes, Make it so' : 'Yes, This is the way.'}</Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );
};

export default deleteConfirmationModal;
